import React, { useCallback } from 'react'
import { css } from '@emotion/react'
import MessageCard from '@groovehq/internal-design-system/lib/components/MessageCard/MessageCard'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { styles as headingStyles } from '@groovehq/internal-design-system/lib/styles/elements/Heading/heading.styles'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_CHANNELS_SELECT_EMAIL } from 'ducks/drawers/types'

const breakStyle = css`
  display: none;
  @media (min-width: 1250px) {
    display: inline;
  }
`

const TrialSetupMessageCard = () => {
  const { openDrawer: openAddDrawer } = useDrawer({
    type: DRAWER_TYPE_CHANNELS_SELECT_EMAIL,
    lazyLoad: true,
  })

  const onAddClick = useCallback(
    () => {
      openAddDrawer('new')
    },
    [openAddDrawer]
  )

  return (
    <MessageCard
      type="positive"
      isIconHidden
      css={css`
        margin: 32px;
        & > div {
          min-width: 100%;
        }
      `}
    >
      <div className="grui flex">
        <div className="grui mr-14 flex-grow">
          <h1
            css={[
              headingStyles.h4,
              css`
                font-size: var(--fontSize-xlarge);
              `,
            ]}
            className="grui mt-4 mb-4"
          >
            Getting Started with Groove
          </h1>
          <p
            className="grui mt-0 mb-0"
            css={css`
              font-size: var(--fontSize-large);
            `}
          >
            Organize all your support requests in one place, collaborate with
            your team, <br css={breakStyle} />and respond faster to customers.
          </p>
        </div>
        <div className="grui flex items-center flex-shrink-0">
          <Button size="small" type="primary" onClick={onAddClick}>
            Add your first {app.t('mailbox')}
          </Button>
        </div>
      </div>
    </MessageCard>
  )
}

export default TrialSetupMessageCard
